import "./footerNav.mobile.css";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Plus } from "../../assets";
import Modal from "../Modal/Modal";
import { CreateEvent, SuccessModal } from "../Modal";

function FooterNav({ bottomNavBarMenu }) {
	const [showModal, setShowModal] = useState(false);
	const [modalContent, setModalContent] = useState(null);

	// Handle Create Event:
	const handleCreateEvent = () => {
		setShowModal(true);
		setModalContent(
			<CreateEvent
				title="New Event"
				onClose={() => setShowModal(false)}
				handleShowSuccessModal={handleShowSuccessModal}
			/>
		);
	};

	// Handle Show Success Modal:
	const handleShowSuccessModal = () => {
		setShowModal(true);
		setModalContent(
			<SuccessModal
				mode="fromCreate"
				title="Event Created"
				message="Event has been created successfully"
				onClose={() => setShowModal(false)}
				handleCreateEvent={handleCreateEvent}
			/>
		);
	};

	return (
		<>
			<nav className="bottom_nav_bar">
				<div className="bottomNavbar-menu">
					<div className="bottomNavbar-add-event" onClick={handleCreateEvent}>
						<img src={Plus} alt="Plus" />
					</div>

					{bottomNavBarMenu.map((item, index) => (
						<NavLink
							to={item.path}
							key={index}
							className="bottomNavbar-link"
							activeclassname="active"
						>
							<div className="bottomNavbar-icon">{item.icon}</div>
							<div className="bottomNavbar-indicator">{item.indicator}</div>
						</NavLink>
					))}
				</div>
			</nav>

			{/* Modal */}
			{showModal && <Modal modalContent={modalContent} />}
		</>
	);
}

export default FooterNav;
